import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    /* margin-right: var(--space-sm); */
`;
